module.exports = __webpack_public_path__ + "static/media/Dec_2025_2.266d78c9.webp";